import { render, staticRenderFns } from "./select-secondary.vue?vue&type=template&id=ba255d78&scoped=true&"
import script from "./select-secondary.vue?vue&type=script&lang=js&"
export * from "./select-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba255d78",
  null
  
)

export default component.exports